import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { BodyMain, Space } from '@/components';
import { FPSLayout } from '@/layout';
import { makeSelectIsMobileView } from '@/model/global/selectors';
import { proceedToForm, savePhone } from '@/model/withdrawal/actions';
import { makeSelectPhone } from '@/model/withdrawal/selectors';
import { WithdrawalUIState } from '@/model/withdrawal/types';
import { ReceiverItem } from '@/pages/withdrawal/components';

interface ReceiverPageViewProps {
  'data-test'?: string;
  backPath?: string;
  shortPhoneMask?: boolean;
}

const selectPhone = makeSelectPhone();
const selectIsMobile = makeSelectIsMobileView();

export const ReceiverPageView: React.FC<ReceiverPageViewProps> = ({
  backPath,
  shortPhoneMask,
  'data-test': dataTest,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const phone = useSelector(selectPhone);
  const isMobile = useSelector(selectIsMobile);
  return (
    <FPSLayout
      data-test={dataTest && `${dataTest}-layout`}
      minHeight={300}
      buttons={{
        back: backPath,
        logout: <FormattedMessage id="withdrawal.logout.button.title" />,
        main: {
          submit: true,
          onAct: async (): Promise<void> => {
            const { error } = await proceedToForm()(dispatch);
            if (!error) {
              history.push(`${WithdrawalUIState.PREPARE}`);
            }
          },
          disabled:
            // prettier-ignore
            // prettier: FIXME: https://github.com/prettier/prettier/pull/7111
            !phone?.value
            || phone?.value.length === 0
            || phone?.hasError,
          title: <FormattedMessage id="withdrawal.pages.receiver.submit.title" />,
        },
      }}
      header={{
        title: <FormattedMessage id="withdrawal.pages.receiver.title" />,
      }}
    >
      <Space direction="vertical" size={isMobile ? 2 : 4}>
        <BodyMain data-test={dataTest && `${dataTest}-description`}>
          <FormattedMessage id="withdrawal.pages.receiver.description" />
        </BodyMain>
        <ReceiverItem
          data-test={dataTest && `${dataTest}-receiver`}
          shortPhoneMask={shortPhoneMask}
          value={{
            value: phone?.value ? { phone: phone.value } : undefined,
            hasError: !!phone?.hasError,
          }}
          onChange={async (newPhone: string): Promise<void> => {
            await savePhone({ phone: newPhone })(dispatch);
          }}
        />
      </Space>
    </FPSLayout>
  );
};

export default ReceiverPageView;
